import React from 'react';
import { saveTheDateDesignsPageData } from '@data-ts/pages/save-the-date';
import {
  SectionContainer,
  TextPairingContainer,
  StyledTextPairFlex,
  StyledLeftImage,
  StyledRightImage,
  StyledMobileImage,
  StyledBottomImageWrapper,
  VideoWrapper,
  BackgroundGradient,
} from './WonderfulWebsiteSectionV2.styles';
import { Columns } from '@components/Columns';
import { Box } from '@components/Box';
import { CTALink } from '@components/CTALink';
import { Flex } from '@sections/newsroom/BrandAssetSection/BrandAssetSection.styles';
import { VimeoVideo } from '@components/VimeoVideo';

export const WonderfulWebsiteSectionV2: React.FC = () => {
  const { wonderfulWebsiteSection } = saveTheDateDesignsPageData;
  const sectionId = 'WonderfulWebsiteSection';
  return (
    <SectionContainer marginTop={[10, 6]} marginBottom={[11, 8]} id={sectionId}>
      <BackgroundGradient />
      <Columns centered>
        <Columns.Column width={12}>
          <StyledTextPairFlex flexDirection="column">
            <TextPairingContainer
              eyebrow={wonderfulWebsiteSection.eyebrow}
              eyebrowColor="humanaDark4"
              eyebrowVariant={'sectionEyeBrow20'}
              eyebrowTagName="h2"
              alignment={'center'}
              title={wonderfulWebsiteSection.title}
              titleVariant={'hed56'}
              titleColor="neutra6"
              titleTagName="h2"
              body={wonderfulWebsiteSection.body}
              bodyColor="neutra6"
              bodyVariant="featureCopy17"
            />
            <Box marginTop={[6]}>
              <CTALink
                id="explore-guest-list"
                hasChevron={true}
                aria-label="Wedding Website"
                typography="featureHed17"
                href="/wedding-website"
              >
                {wonderfulWebsiteSection.learnMore}
              </CTALink>
            </Box>
          </StyledTextPairFlex>
        </Columns.Column>
      </Columns>
      <StyledBottomImageWrapper verticalAlign="center" centered>
        <Columns.Column width={12}>
          <Flex>
            <VideoWrapper>
              <VimeoVideo
                posterUrl={wonderfulWebsiteSection.posterUrl}
                embedUrl={wonderfulWebsiteSection.videoUrl}
                title={wonderfulWebsiteSection.title}
                autoPlay
                background
                controls={false}
                autoPause={false}
                alt="create-invite"
                muted
                loop
                cover
                posterOptimization="aggressive"
              />
            </VideoWrapper>
          </Flex>
        </Columns.Column>
      </StyledBottomImageWrapper>
      <StyledLeftImage src="save-the-date-gallery/ww-left_v2.png" />
      <StyledRightImage src="save-the-date-gallery/ww-right_v2.png" />
      <StyledMobileImage src="save-the-date-gallery/ww-mobile_v2.png" />
    </SectionContainer>
  );
};
